import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

export const RateQuotePDF = async ({ formData, salesPersonList = [], clauses = [], MasterCompanyDetails = {} }) => {

    const carrierTab = formData?.CarrierDetails?.map((singlecarrier, key) => {
        const tableHeadHtml = singlecarrier?.rateQuoteContainer
            ?.map(charge => `<th style="padding:12px 8px; text-align:left; font-weight:600; color:#374151; font-size:12px;">${charge?.numberOfContainer} X ${charge?.contTypeName}</th>`)
            .join('');

        const tableRowsHtml = singlecarrier?.rateCharges?.map((charge, index) => {
            const containerCells = singlecarrier?.rateQuoteContainer?.map((c, i) => {
                const rate = charge?.['set' + (i + 1) + 'sellrate'] ?? 0;
                return `<td style="padding:8px 8px; border-bottom:1px solid #e5e7eb;">$${rate.toFixed(2)}</td>`;
            }).join('');
            return `
            <tr>
                <td style="padding:8px 8px; border-bottom:1px solid #e5e7eb;">${charge?.chargedescription || ''}</td>
                <td style="padding:8px 8px; border-bottom:1px solid #e5e7eb;">${charge?.currency || currency}</td>
                <td style="padding:8px 8px; border-bottom:1px solid #e5e7eb;">${charge?.basis || 'per cntr'}</td>
                ${containerCells}
            </tr> `;
        }).join('');

        const grandTotalCellsHtml = singlecarrier?.rateQuoteContainer?.map((c, i) => {
            let grandTotal = 0;

            singlecarrier?.rateCharges?.forEach((charge) => {
                const rate = charge?.['set' + (i + 1) + 'sellrate'] || 0;
                grandTotal += rate;
            });

            return `<td style="padding:12px 8px; border-bottom:1px solid #e5e7eb; font-weight:700;">$${grandTotal.toFixed(2)}</td>`;
        }).join('');


        const vesselInfo = singlecarrier?.ratequoteVessel?.map((v, i) => {
            return `
                <tr style="border-bottom:1px solid #e5e7eb; font-weight:400; color:#4b5563;">
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-left:12px;">
                        ${v?.vesselName || '-'}
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        ${v?.voyage || '-'}
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        ${v?.cargoCutoff ? moment(v?.cargoCutoff).format('DD MMM YYYY') : '-'}
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        ${v?.etd ? moment(v?.etd).format('DD MMM YYYY') : '-'}
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        ${v?.eta ? moment(v?.eta).format('DD MMM YYYY') : '-'}
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        ${v?.transitTime || '-'}
                    </td>
                </tr>
            `;
        }).join('');


        return (`
            <!-- Carrier & Ports Section -->
                <table style="width:100%; background-color:#f3f4f6; margin-bottom:24px; border-collapse:collapse; border:1px solid #9ca3af;">
                    <tr>
                        <td style="flex:1; padding:8px 12px; font-size:12px; font-weight:600; color:#111827; border-right:1px solid #9ca3af; width:33.3%;">CARRIER: ${singlecarrier?.carrierName}</td>
                        <td style="flex:1; padding:8px 12px; font-size:12px; font-weight:600; color:#111827; border-right:1px solid #9ca3af; width:33.3%;">POL: ${formData?.portOfLoad}</td>
                        <td style="flex:1; padding:8px 12px; font-size:12px; font-weight:600; color:#111827; width:33.3%;">POD: ${formData?.portOfDischarge}</td>
                    </tr>
                </table>

                <!-- Vessel -->
                <table style="width:100%; margin-bottom:24px; font-size:11px;"> 
                    <tr style="border-bottom:1px solid #e5e7eb; font-weight:900; color:#4b5563;">
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-left:12px;">
                            Vessel
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            Voyage
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            C/O
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            ETD
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            ETA
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            Transit Time
                        </td>
                    </tr>
                    ${vesselInfo}
                </table>

                <!-- Charges Table -->
                <table style="width:100%; border-collapse:collapse; font-size:12px; margin-bottom:24px;">
                    <thead>
                        <tr style="border-bottom:1px solid #d1d5db;">
                            <th style="padding:12px 8px; text-align:left; font-weight:600; color:#374151; font-size:12px;">Charge Description</th>
                            <th style="padding:12px 8px; text-align:left; font-weight:600; color:#374151; font-size:12px;">Currency</th>
                            <th style="padding:12px 8px; text-align:left; font-weight:600; color:#374151; font-size:12px;">Basis</th>
                            ${tableHeadHtml}
                        </tr>
                    </thead>
                    <tbody>
                        ${tableRowsHtml}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td style="padding:12px 8px; border-bottom:1px solid #e5e7eb;"></td>
                            <td style="padding:12px 8px; border-bottom:1px solid #e5e7eb;"></td>
                            <td style="padding:12px 8px; border-bottom:1px solid #e5e7eb; font-weight:700;">Grand Total</td>
                            ${grandTotalCellsHtml}
                        </tr>
                    </tfoot>
                </table>

                
            `
        );
    }).join('');


    const toBase64 = async (url) => {
        try {
            const encodedUrl = encodeURI(url);
            const res = await fetch(encodedUrl, {
                mode: "cors",
                cache: "no-cache"
            });
            const blob = await res.blob();
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Failed to convert image to base64:", error);
            return null;
        }
    }

    const imageLogoBase64 = await toBase64("/shipez-logo.png");
    const imageLogo = 'http://app.shipez.ai/shipez-logo.png';

    const SalesPersonName = (id) => {
        return salesPersonList.find(item => item.salesPersonId === id)?.salesPerson || "N/A";
    };

    const clausesHtml = clauses?.length > 0 ? clauses.map((clause, index) => {
        return `
            <tr style="border-bottom:1px solid #e5e7eb; font-weight:400; color:#4b5563;">
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-left:12px;">
                    ${clause?.ClauseType || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${clause?.ModuleType || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${clause?.ClausesCategoryType || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${clause?.ClauseDescription || '-'}
                </td>
            </tr>
        `;
    }).join('') : '';

    const cargoHtml = formData?.cargoUnits?.map((unit) => {
        return `
            <tr style="border-bottom:1px solid #e5e7eb; font-weight:400; color:#4b5563;">
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-left:12px;">
                    ${unit?.pices_No || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${unit?.units_Type || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${unit?.description || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    <table>
                        <tr>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.dimensions_L || '-'}</td>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.dimensions_W || '-'}</td>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.dimensions_H || '-'}</td>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.dimensions_Type || '-'}</td>
                        </tr>
                    </table>
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    <table>
                        <tr>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.weights_KG || '-'}</td>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.weights_LB || '-'}</td> 
                        </tr>
                    </table>
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    <table>
                        <tr>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.measurment_CFT || '-'}</td>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.measurment_CBM || '-'}</td> 
                        </tr>
                    </table>
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${unit?.container_ForUnit || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${unit?.hsCode || '-'}
                </td>
            </tr>
        `;
    }).join('');

    const companyAddressLines = (MasterCompanyDetails?.[0]?.ProfileAddressPrint || "")
        .split(",")
        .map((l) => `<p style="margin:0;font-size:11px;color:#555;">${l.trim()}</p>`)
        .join("");

    const logoUrl = MasterCompanyDetails?.[0]?.CompanyLogoDark ? await toBase64(MasterCompanyDetails[0].CompanyLogoDark) : imageLogoBase64;


    const html = ` 
    <!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Rate Quote</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            background-color: #f3f4f6;
            padding: 20px;
            height:100%;
        }

        .container {
            max-width: 100%;
            margin: 0 auto;
            background-color: white;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            border: 1px solid #e5e7eb;
        }

        .header {
            padding: 24px;
            border-bottom: 1px solid #e5e7eb;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
        }

        .logo-section {
            
        }

        .logo-section img {
            height: auto;
            width: 150px;
        }

        .logo-text {
            font-size: 11px;
            color: #9ca3af;
            margin-top: 4px;
        }

        .company-info {
            text-align: right;
            font-size: 11px;
            color: #4b5563;
            line-height: 1.6;
        }

        .company-info p {
            margin: 0;
        }

        .content {
            padding: 24px;
        }

        .section {
            margin-bottom: 24px;
            border: 1px solid #9ca3af;
        }

        .section-header {
            background-color:#d9d9d9;
            color:#000;
            padding: 8px 12px 20px;
            font-weight: 700;
            font-size: 13px;
            line-height: 13px;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin: 0;                   /* remove default margin */
            display: block;               /* makes alignment predictable */
            align-items: center;         /* vertically center text */
            box-sizing: border-box;
        }

        .section-body {
            padding: 0;
        }

        .two-column {
            display: flex;
        }

        .column {
            flex: 1;
            padding: 12px;
            font-size: 12px;
        }

        .column.right {
            border-left: 1px solid #9ca3af;
        }

        .customer-name {
            font-weight: 600;
            color: #111827;
            font-size: 14px;
            margin-bottom: 8px;
        }

        .customer-details {
            font-size: 11px;
            color: #374151;
            line-height: 1.6;
            white-space: pre-wrap;
            margin-bottom: 8px;
        }

        .info-row {
            margin-bottom: 4px;
            font-size: 11px;
        }

        .info-label {
            font-weight: 600;
            color: #4b5563;
        }

        .info-value {
            color: #111827;
        }

        .info-table {
            width: 100%;
            font-size: 11px;
            border-collapse: collapse;
        }

        .info-table tr {
            border-bottom: 1px solid #e5e7eb;
        }

        .info-table tr:last-child {
            border-bottom: none;
        }

        .info-table td { 
            vertical-align: top;
            padding-top: 6px;
            padding-bottom: 12px;
        }

        .info-table td:first-child {
            font-weight: 600;
            color: #4b5563;
            width: 120px;
            padding-right: 12px;
        }

        .info-table td:last-child {
            color: #111827;
        }

        .carrier-ports {
            display: flex;
            background-color: #f3f4f6; 
        }

        .carrier-port-item {
            flex: 1;
            padding: 8px 12px;
            font-size: 12px;
            line-height:12px;
            font-weight: 600;
            color: #111827;
            border-right: 1px solid #9ca3af;
        }

        .carrier-port-item:last-child {
            border-right: none;
        }

        .charges-table {
            width: 100%;
            border-collapse: collapse;
            font-size: 12px;
            margin-bottom: 24px;
        }

        .charges-table thead {
            border-bottom: 1px solid #d1d5db;
        }

        .charges-table th {
            padding: 12px 8px;
            text-align: left;
            font-weight: 600;
            color: #374151;
            font-size: 12px;
        }

        .charges-table td {
            padding: 12px 8px;
            border-bottom: 1px solid #e5e7eb;
        }

        .charges-table tfoot td{
            font-weight:bold;
        }

        .charge-desc {
            font-weight: 600;
            text-transform: uppercase;
            color: #111827;
        }

        .grand-total-row td {
            font-weight: 700;
            padding-top: 16px;
            border-top: 2px solid #111827;
        }

        .remarks-section {
            margin-bottom: 24px;
        }

        .remarks-title {
            font-weight: 700;
            font-size: 13px;
            text-transform: uppercase;
            color: #111827;
            margin-bottom: 12px;
        }

        .remarks-text {
            font-size: 11px;
            color: #374151;
            text-transform: uppercase;
            line-height: 1.6;
            white-space: pre-wrap;
        }

        .footer {
            border-top: 1px solid #d1d5db;
            padding-top: 16px;
            margin-top: 24px;
        }

        .footer-grid {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
        }

        .footer-item {
            font-size: 11px;
            flex: 1;
        }

        .footer-item.right {
            text-align: right;
        }

        .footer-label {
            color: #9ca3af;
            margin-bottom: 4px;
            font-size: 11px;
        }

        .footer-content {
            font-weight: 600;
            color: #111827;
            font-size: 13px;
        }

        .footer-subtext {
            font-size: 11px;
            color: #6b7280;
        }

        .signature-line {
            border-bottom: 1px solid #9ca3af;
            height: 24px;
            margin-bottom: 4px;
        }

        .signature-date {
            font-size: 10px;
            color: #9ca3af;
        }

        .footer-bottom {
            margin-top: 12px;
            padding-top: 12px;
            border-top: 1px solid #e5e7eb;
            text-align: center;
            font-size: 11px;
            color: #9ca3af;
        }

        @media (max-width: 600px) {
            .header {
                flex-direction: column;
                gap: 16px;
            }

            .company-info {
                text-align: left;
            }

            .two-column {
                flex-direction: column;
            }

            .column.right {
                border-left: none;
                border-top: 1px solid #9ca3af;
                margin-top: 12px;
                padding-top: 12px;
            }

            .carrier-ports {
                flex-direction: column;
            }

            .carrier-port-item {
                border-right: none;
                border-bottom: 1px solid #9ca3af;
                padding: 8px 12px;
            }

            .carrier-port-item:last-child {
                border-bottom: none;
            }

            .footer-grid {
                flex-direction: column;
                gap: 16px;
            }

            .footer-item.right {
                text-align: left;
            }
        }
    </style>
</head>

<body>
    <div class="container">
        <!-- Header -->
        <div class="header">
            <div class="logo-section" style="width:33.3%;">
                <img src="${logoUrl}" alt="Company Logo" crossorigin="anonymous"> 
            </div>
            <div style="width:33.3%;">
                <h1 style="font-size:20px; font-weight:bold; color:#000; text-transform:uppercase; letter-spacing:0.05em; text-align:center;">
                    RATE QUOTATION
                </h1>
            </div>
            <div class="company-info" style="width:33.3%;">
                ${companyAddressLines}
            </div>
        </div>

        <!-- Content -->
        <div class="content">
            <!-- Customer Section -->
            <div class="section">
                <div class="section-header">Customer</div>
                <div class="section-body">
                    <div class="two-column">
                        <div class="column" style="width:50%;">
                            <div class="customer-name">${formData?.customerName}</div>
                            <div class="customer-details">${formData?.customerAddress}</div>
                            <div class="info-row"><span class="info-label">TEL:</span> <span
                                    class="info-value">${formData?.customerTel}</span></div>
                            <div class="info-row"><span class="info-value">${formData?.customerEmail}</span></div>
                        </div>
                        <div class="column right" style="width:50%;">
                            <table class="info-table">
                                <tr>
                                    <td>RQ NUMBER</td>
                                    <td>: ${formData?.rateQuoteNumber}</td>
                                </tr>
                                <tr>
                                    <td>QUOTE DATE</td>
                                    <td>: ${formData?.createdOn ? moment(formData?.createdOn).format('DD MMM YYYY') : ''}</td>
                                </tr>
                                <tr>
                                    <td>EFFECTIVE DATE</td>
                                    <td>: ${formData?.effectiveDate ? moment(formData?.effectiveDate).format('DD MMM YYYY') : ''}</td>
                                </tr>
                                <tr>
                                    <td>EXPIRY DATE</td>
                                    <td>: ${formData?.valideDate ? moment(formData?.valideDate).format('DD MMM YYYY') : ''}</td>
                                </tr>
                                <tr>
                                    <td>QUOTED BY</td>
                                    <td>: ${formData?.quotedBy}</td>
                                </tr>
                                <tr>
                                    <td>SALES PERSON</td>
                                    <td>: ${SalesPersonName(formData?.salesPersonSno)}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Routing Instruction Section -->
            <table style="width:100%; margin-bottom:24px; border:1px solid #9ca3af;">
                <tr>
                    <td colspan="2" style="background-color:#d9d9d9; color:#000; padding:8px 12px 20px; font-weight:700; font-size:13px; line-height:13px; text-transform:uppercase; letter-spacing:0.05em;">
                        Routing Instruction
                    </td>
                </tr>
                <tr>
                    <td style="width:50%; padding:12px; font-size:12px; border-right:1px solid #9ca3af;">
                        <table style="width:100%; font-size:11px; border-collapse:collapse;">
                            <tr style="border-bottom:1px solid #e5e7eb;">
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">MOVE TYPE</td>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.moveType}</strong></td>
                            </tr>
                            <tr>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">PLACE OF RECEIPT</td>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.origin}</strong></td>
                            </tr>
                            <tr>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> PORT OF LOADING</td>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.portOfLoad}</strong></td>
                            </tr> 
                            <tr>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> TRANSIT TIME</td>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.transitTime}</strong></td>
                            </tr>
                        </table>
                    </td>
                    <td style="width:50%; padding:12px; font-size:12px;">
                        <table style="width:100%; font-size:11px; border-collapse:collapse;">
                            <tr style="border-bottom:1px solid #e5e7eb;">
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> PORT OF DISCHARGE </td>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.portOfDischarge}</strong></td>
                            </tr>
                            <tr>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> PLACE OF DELIVERY</td>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.destination}</strong></td>
                            </tr>
                            <tr>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> LOADING LOCATION</td>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.loadingLoc}</strong></td>
                            </tr>
                            <tr>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> COMMODITY</td>
                                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.commodity}</strong></td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
 

            ${carrierTab}

            ${formData?.shippingTerm != 'FCL' && (`<table style="width:100%; margin-bottom:24px; border:1px solid #9ca3af; font-size:11px;">
                <tr>
                    <td colspan="8" style="background-color:#d9d9d9; color:#000; padding:8px 12px 20px; font-weight:700; font-size:13px; line-height:13px; text-transform:uppercase; letter-spacing:0.05em; vertical-align:middle;">
                        Cargo Details
                    </td>
                </tr>
                <tr  style="border-bottom:1px solid #e5e7eb; font-weight:900; color:#4b5563;">
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-left:12px;">
                        Pc
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        Pkg
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        Marks & Numbers
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        Dimensions
                        <table>
                            <tr>
                                <td style="padding:4px 8px; font-weight:600; color:#4b5563;">L</td>
                                <td style="padding:4px 8px; font-weight:600; color:#4b5563;">W</td>
                                <td style="padding:4px 8px; font-weight:600; color:#4b5563;">H</td>
                                <td style="padding:4px 8px; font-weight:600; color:#4b5563;">Type</td>
                            </tr>
                        </table>
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        Weight
                        <table>
                            <tr>
                                <td style="padding:4px 8px; font-weight:600; color:#4b5563;">KG</td>
                                <td style="padding:4px 8px; font-weight:600; color:#4b5563;">LB</td>
                            </tr>
                        </table>
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        Measurement
                        <table>
                            <tr>
                                <td style="padding:4px 8px; font-weight:600; color:#4b5563;">CFT</td>
                                <td style="padding:4px 8px; font-weight:600; color:#4b5563;">CBM</td>
                            </tr>
                        </table>
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        Cntr
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        HS
                    </td>
                </tr>
                ${cargoHtml}
            </table>`)}

            ${clauses.length > 0 && (` <table style="width:100%; margin-bottom:24px; border:1px solid #9ca3af; font-size:11px;">
                <tr>
                    <td colspan="4" style="background-color:#d9d9d9; color:#000; padding:8px 12px 20px; font-weight:700; font-size:13px; line-height:13px; text-transform:uppercase; letter-spacing:0.05em; vertical-align:middle;">
                        Clause
                    </td>
                </tr>
                <tr  style="border-bottom:1px solid #e5e7eb; font-weight:900; color:#4b5563;">
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-left:12px;">
                        CLAUSE TYPE
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        MODULE TYPE
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        CLAUSE CATEGORY
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        DESCRIPTION
                    </td>
                </tr>
                ${clausesHtml}
            </table>`)}

            <!-- Remarks Section -->
            <div class="remarks-section">
                <div class="remarks-title">Customer Remarks:</div>
                <div class="remarks-text">${formData?.customerRemarks || `BASED ON GENERAL CARGO.\nOCEANFREIGHT IS INCLUSIVE OF BUNKER, ISPS, TERMINAL, PORT, LOW SULFUR AND ENERGY SURCHARGE.`}</div>
            </div>

            <!-- Footer -->
            <div class="footer">
                <div class="footer-grid">
                    <div class="footer-item">
                        <div class="footer-label">Prepared By:</div>
                        <div class="footer-content">${formData?.createdBy}</div>
                        <div class="footer-subtext">Shipez AI</div>
                    </div>
                    <div class="footer-item right">
                        <div class="footer-label">Customer Acceptance:</div>
                        <div class="signature-line"></div>
                        <div class="signature-date">Signature &amp; Date</div>
                    </div>
                </div>

                <div class="footer-bottom">
                    Thank you for choosing Shipez AI | www.shipez.ai
                </div>
            </div>
        </div>
    </div>
</body>

</html>
    `;
    return html;
};